import { TripType } from '@fcom/core/constants';

import { OfferListFetchParams, Step } from '../interfaces';
import { GlobalBookingState } from '../store';
import { BOOKING_STEPS } from '../config/booking-config';

export const createParamsForStep = (
  step: Step,

  common: GlobalBookingState,
  offerListParams: OfferListFetchParams
): { json?: string } => {
  if (step.id !== BOOKING_STEPS.FLIGHT_SELECTION.id) {
    return null;
  }

  /**
   * If the session has expired and there is no longer a search query in the store then don't try
   * and encode any "initialState" data into the url.
   **/
  if (!common?.locations?.[0]?.origin) {
    return null;
  }

  const flightSelectionParams = {
    flights: common?.locations?.map((location, index) => ({
      origin: location.origin?.locationCode,
      destination: location.destination?.locationCode,
      departureDate: index === 0 ? common?.dates?.departureDate?.toString() : common?.dates?.returnDate?.toString(),
    })),
    cabin: common?.travelClasses?.selected,
    adults: common?.paxAmount?.adults,
    c15s: common?.paxAmount?.c15s,
    children: common?.paxAmount?.children,
    infants: common?.paxAmount?.infants,
    departureDate: common?.dates?.departureDate?.toString(),
    returnDate: common?.tripType === TripType.RETURN ? common?.dates?.returnDate?.toString() : null,
    directFlights: offerListParams?.directFlights,
    isAward: offerListParams?.isAward || null,
  };

  return {
    json: encodeURIComponent(JSON.stringify(flightSelectionParams)),
  };
};
